import { useCallback, useEffect } from 'react';
import { useSWRConfig } from 'swr';

/**
 * Revalidate cached data when the window regains focus. Ports the Next app's
 * `useAutoRefresh`, which called `router.refresh()` to re-run server components
 * on focus. In the SPA, data comes from SWR, so we revalidate all cached keys.
 */
export function useAutoRefresh() {
  const { mutate } = useSWRConfig();

  const focusListener = useCallback(() => {
    mutate(() => true, undefined, { revalidate: true });
  }, [mutate]);

  useEffect(() => {
    window.addEventListener('focus', focusListener);
    return () => window.removeEventListener('focus', focusListener);
  }, [focusListener]);
}
